import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import ProjectCard from "./ProjectCards";

import PrivateChat from "../../Assets/Projects/PrivateChat.png";
import Portfolio from "../../Assets/Projects/Portfolio.png";
import Ecart from "../../Assets/Projects/ecart.png";
import ExpenseTracker from "../../Assets/Projects/ExpenseTracker.png";

import "./project.css";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="Fluorescent-Blue">Works </strong>
        </h1>
        <p>Here are a few projects I've worked on recently.</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={Ecart}
              title="E Cart"
              description="I have created the back-end of an E‐commerce website with
              multiple APIs for users, products, and cart orders. Like : Amazon
              etc.
               In this project, I use Aws S3, Nodejs, and many npm libraries like multer,
              express, "
              ghLink="github.com/sourabhku88/shooping-cart"
            />
          </Col>

          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={Portfolio}
              title="URL-Shortner"
              description="URL shortening is used to create shorter aliases for long URLs. We Implement Redis for faster response."
              ghLink="https://github.com/sourabhku88/Project_4_url_shortner"
            />
          </Col>
          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={PrivateChat}
              title="Books-Management"
              description="The project is a MERN stack project for managing a library system. 
              Users can read books and give ratings to the books they have read, like Kindle platform.
              Through JWT authentication and authorization to make security."
              ghLink="https://github.com/sourabhku88/Project-bookmanagment"
            />
          </Col>

          <Col md={6} lg={4} className="project-card">
            <ProjectCard
              imgPath={ExpenseTracker}
              title="Open-to-intern"
              description="I have created backend API's for internships Application.
              In this project I  used AWS S3."
              ghLink="https://github.com/sourabhku88/project2-intern"
            />
          </Col>
        </Row>
      </Container>
      <ScrollToTop />
    </Container>
  );
}

export default Projects;
